
import { motion } from 'framer-motion';

export default function TargetAudience() {
  return (
    <section className="py-24 px-6 bg-black relative overflow-hidden">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#0066FF]/10 rounded-full blur-[120px]"></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-20"
        >
          <div className="inline-block px-4 py-2 bg-[#0066FF]/10 border border-[#0066FF]/20 rounded-full mb-6">
            <span className="text-sm font-semibold text-[#0066FF]">Für wen ist die Suite?</span>
          </div>
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-6">
            Perfekt für SuperOne-Partner
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            Egal ob du gerade startest oder bereits erfolgreich bist – die Business Suite unterstützt dich auf jedem Level
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8 mb-16">
          {/* Einsteiger */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 border border-gray-800"
          >
            <div className="w-16 h-16 bg-green-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-seedling-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Einsteiger</h3>
            <p className="text-gray-400 mb-6">
              Du startest gerade als SuperOne-Partner und brauchst ein System, das dir den Einstieg erleichtert
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300 text-sm">Einfache Einrichtung in Minuten</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300 text-sm">Schritt-für-Schritt Schulungen</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300 text-sm">Vorgefertigte Templates</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-green-400 mt-1"></i>
                <span className="text-gray-300 text-sm">Automatisierte Prozesse</span>
              </div>
            </div>
          </motion.div>

          {/* Fortgeschrittene */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 border border-[#0066FF]"
          >
            <div className="w-16 h-16 bg-[#0066FF] rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-rocket-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Fortgeschrittene</h3>
            <p className="text-gray-400 mb-6">
              Du hast bereits Erfahrung und möchtest deine Prozesse optimieren und skalieren
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#0066FF] mt-1"></i>
                <span className="text-gray-300 text-sm">Erweiterte Automatisierung</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#0066FF] mt-1"></i>
                <span className="text-gray-300 text-sm">Detaillierte Analytics</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#0066FF] mt-1"></i>
                <span className="text-gray-300 text-sm">Team-Management</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-[#0066FF] mt-1"></i>
                <span className="text-gray-300 text-sm">Individuelle Anpassungen</span>
              </div>
            </div>
          </motion.div>

          {/* Profis */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-gradient-to-br from-gray-900 to-black rounded-3xl p-8 border border-gray-800"
          >
            <div className="w-16 h-16 bg-purple-500 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-vip-crown-line text-white text-2xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-white mb-4">Profis</h3>
            <p className="text-gray-400 mb-6">
              Du bist bereits sehr erfolgreich und brauchst maximale Effizienz und Kontrolle
            </p>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-purple-400 mt-1"></i>
                <span className="text-gray-300 text-sm">Unbegrenzte Skalierung</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-purple-400 mt-1"></i>
                <span className="text-gray-300 text-sm">KI-gestützte Optimierung</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-purple-400 mt-1"></i>
                <span className="text-gray-300 text-sm">Priority Support</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-purple-400 mt-1"></i>
                <span className="text-gray-300 text-sm">Exklusive Features</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Use Cases */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h3 className="text-3xl font-bold text-white text-center mb-12">Typische Anwendungsfälle</h3>
          
          <div className="grid md:grid-cols-2 gap-8">
            {/* B2C Use Case */}
            <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 border border-gray-800">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-green-500/20 rounded-xl flex items-center justify-center">
                  <i className="ri-user-heart-line text-green-400 text-xl"></i>
                </div>
                <h4 className="text-xl font-bold text-white">B2C: Endkunden gewinnen</h4>
              </div>
              <p className="text-gray-400 mb-6">
                Nutze personalisierte Landingpages und bewirb sie über Social Media, um Privatpersonen zu erreichen
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <i className="ri-arrow-right-s-line text-green-400"></i>
                  <span>Facebook & Instagram Ads</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <i className="ri-arrow-right-s-line text-green-400"></i>
                  <span>TikTok Marketing</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <i className="ri-arrow-right-s-line text-green-400"></i>
                  <span>WhatsApp & E-Mail Kampagnen</span>
                </div>
              </div>
            </div>

            {/* B2B Use Case */}
            <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 border border-gray-800">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-12 h-12 bg-[#0066FF]/20 rounded-xl flex items-center justify-center">
                  <i className="ri-building-line text-[#0066FF] text-xl"></i>
                </div>
                <h4 className="text-xl font-bold text-white">B2B: Geschäftskunden finden</h4>
              </div>
              <p className="text-gray-400 mb-6">
                Finde automatisch lokale Unternehmen in deiner Zielbranche und kontaktiere sie direkt
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <i className="ri-arrow-right-s-line text-[#0066FF]"></i>
                  <span>Finanzberater & Versicherungen</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <i className="ri-arrow-right-s-line text-[#0066FF]"></i>
                  <span>Agenturen & Berater</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-300">
                  <i className="ri-arrow-right-s-line text-[#0066FF]"></i>
                  <span>Vertriebspartner</span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
